export default "__VITE_ASSET__c09035f1__"